import { render, staticRenderFns } from "./Print_phone.vue?vue&type=template&id=488bc65e&scoped=true"
import script from "./Print_phone.vue?vue&type=script&lang=js"
export * from "./Print_phone.vue?vue&type=script&lang=js"
import style0 from "./Print_phone.vue?vue&type=style&index=0&id=488bc65e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488bc65e",
  null
  
)

export default component.exports